import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	min-height: fit-content;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	padding: 1rem;
	background-color: ${color.interface.white};
	border-radius: 5px;
	gap: 2rem;
	overflow-y: hidden;
	overflow-x: auto;

	@media (max-width: 1000px) {
		min-height: 70px;
	}
`;

export const box = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1rem;
	min-width: fit-content;
`;

export const title = styled.p`
	font-size: 1.4rem;
	color: ${color.interface.lightGray};
	font-weight: 600;

	@media (max-width: 1000px) {
		font-size: 1.3rem;
	}
`;

export const filterOptions = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1rem;
`;

export const btnBox = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 1rem;
`;
